import { request } from '@/common/utils/request'
// 获取电话信息

export function fetchShopContactInfo(params) {
  return request.get({
    url: 'feidian.bdapp.bizopp.getShopContactInfo',
    params,
  })
}

// 获取商机列表
export function fetchResultList(params) {
  return request.post({
    url: 'feidian.bdapp.bizopp.getSearchResultList',
    params,
  })
}
// 获取商机列表
export function fetchHomeList(params) {
  return request.post({
    url: 'feidian.bdapp.bizopp.getList',
    params,
  })
}

// 获取商机详情
export function fetchBizoppDetail(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getBizoppInfo',
    params,
  })
}
// 根据国家获取品类列表
export function fetchCategoryList(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getCategoryByCountry',
    params,
  })
}

// 获取商机列表title
export function fetchBizoppTitle(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getBizoppStatusStatistical',
    params,
  })
}

// 获取商机账户
export function fetchBizoppBillAccount(params) {
  return request.get({
    url: 'crm.bdapp.bill.account',
    params,
  })
}

// 根据国家获取合同信息中的银行列表
export function fetchAllConfig(params) {
  return request.get({
    url: 'crm.bdapp.index.common.getAllConfig',
    params,
  })
}
// 获取商机列表
export function getStrategyTag(params) {
  return request.get({
    url: 'feidian.bdapp.bizopp.getStrategyTag',
    params,
  })
}

const getBizoppParams = function (params) {
  return {
    name: params.name,
    channel: params.channel,
    nameAlph: params.nameAlph,
    forceSubmit: params.forceSubmit,
    type: 1,
    businessType: params.businessType,
    addr: params.addr,
    selectCityId: params.selectCityId,
    addrAlph: params.addrAlph,
    phone: params.phone,
    postCode: params.postCode,
    kpName: params.kpName,
    kpNameAlph: params.kpNameAlph,
    kpLastName: params.kpLastName,
    kpLastNameAlph: params.kpLastNameAlph,
    kpDepartment: params.kpDepartment,
    kpPhone: params.kpPhone,
    kpEmail: params.kpEmail,
    kpOutId: params.kpOutId,
    kpPics: params.kpPics,
    category: params.category || [],
    platform: params.platform,
    sysPlatform: params.sysPlatform,
    lat: params.lat,
    lng: params.lng,
    logo: params.logo,
    environmentalPhoto: params.environmentalPhoto,
    frontPhoto: params.frontPhoto,
    frontPics: params.frontPics,
    minPrice: params.minPrice,
    deliveryPrice: params.deliveryPrice,
    deliveryDistanceTime: params.deliveryDistanceTime,
    kpContactMode: params.kpContactMode,
    kpContactTime: params.kpContactTime,
    menuUrl: params.menuUrl,
    uberMenuLink: params.uberMenuLink,
    sysUberMenuLink: params.sysUberMenuLink,
    rappiMenuLink: params.rappiMenuLink,
  }
}
// 新增商机
export function addBizopp(params) {
  return request.post({
    url: 'crm.bdapp.bizopp.addApply',
    data: getBizoppParams(params),
  })
}
// 编辑商机
export function updateBizopp(params) {
  return request.post({
    url: 'crm.bdapp.bizopp.update',
    data: {
      shopId: params.shopId,
      ...getBizoppParams(params),
    },
  })
}
// 获取商机sug
export function fetchBizoppSugList(params) {
  return request.get({
    url: 'feidian.bdapp.bizopp.getNameSug',
    params,
  })
}
// 搜索前置下拉框数据
export function getShopListFilter(params) {
  return request
    .get({
      url: 'feidian.perf.getShopListFilter',
      params,
    })
    .then(res => res.data)
}
/**
 * 获取管理视图销售姓名
 * @param {*} params
 * @returns
 */
export async function getManageViewBDNameTree(params = {}) {
  params.special = 1
  return request
    .get({
      url: 'feidian.common.getBdRelationTree',
      params,
    })
    .then(res => {
      return res.data
    })
}
// 获取我的新增商机列表
export function fetchNewBizoppList(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getApplyList',
    params,
  })
}

// 获取新增商机失败详情
export function fetchNewBizoppInfo(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getApplyBizoppInfo',
    params,
  })
}

// 验证新poi信息
export function checkNewPoiInfo(params) {
  return request.post({
    url: 'crm.bdapp.shop.checkNewPoiInfo',
    data: params,
  })
}
// 获取不同国家的银行列表
export function fetchBankList(params) {
  return request.get({
    url: 'crm.bdapp.common.getConfig',
    params,
  })
}
// 根据国家地区等信息获取商机通用配置
export function fetchsBizoppCommonDict(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getBizoppCommonDict',
    params,
  })
}

export function getTagsTree(params) {
  return request
    .get({
      url: 'feidian.bdapp.bizopp.getTagsTree',
      params: {
        ...params,
      },
    })
    .then(({ errno, data, errmsg }) => {
      if (+errno !== 0) {
        throw new Error(errmsg)
      }
      return data
    })
    .catch(e => {
      console.warn(e)
      return []
    })
}
// 新版获取业务标签

// BD申诉创建失败商机
export function fetchsAppealApply(params) {
  return request.post({
    url: 'crm.bizopp.appealApply',
    data: {
      shopId: params.shopId,
    },
  })
}
